module.exports = __webpack_public_path__ + "static/burgermeister-2743a84a05b662124ac502a003b1805d.jpg";